import React from 'react';
import { find, isEmpty } from 'lodash'
import Select from 'UI/Select'
import DatePicker from "react-datepicker";
import moment from 'moment'
import MultiSelect from './EditableColumn/Multiselect';

const EditableColumn = ({
  row,
  type = 'text',
  fieldName,
  fields,
  updateState,
  options
}) => {
  const { column, original } = row
  const columnFieldName = fieldName || column.id
  const handleFieldValue = (value) => {
    updateState((prevState) => {
      const { fields } = prevState

      return { fields: { ...fields, [columnFieldName]: value } }
    })
  }

  if (fields.id === original.id) {
    switch (type) {
      case 'text': return <EditableColumnText {...{ handleFieldValue, columnFieldName, fields }} />
      case 'select': return <EditableColumnSelect {...{ options, handleFieldValue, columnFieldName, fields, isMulti: false }} />
      case 'date': return <EditableColumnDate {...{ handleFieldValue, columnFieldName, fields }} />
      case 'multiselect': return <MultiSelect {...{ options, handleFieldValue, columnFieldName, fields }} />

      default: return (row.value || '')
    }
  }

  if (type === 'date') {
    if (!row.value) return null
    return moment.utc(new Date(row.value)).format('YYYY-MM-DD hh:mm A')
  }

  if (type === 'multiselect') {
    if (isEmpty(row.value)) return null

    return row.value.map(i => i.label).join(', ')
  }

  return row.value || ''
}

const EditableColumnSelect = ({ options, handleFieldValue, columnFieldName, fields }) => (
  <Select
    options={options}
    styles={{ container: base => ({ ...base }) }}
    onChange={option => handleFieldValue(option.value)}
    value={find(options, option => option.value == fields[columnFieldName] || option.label == fields[columnFieldName])}
    menuPortalTarget={document.querySelector("body")}
  />
)

const EditableColumnText = ({ handleFieldValue, columnFieldName, fields }) => (
  <input type="text" value={fields[columnFieldName]} onChange={event => handleFieldValue(event.target.value)} />
)

const EditableColumnDate = ({ handleFieldValue, columnFieldName, fields }) => (
  <DatePicker
    selected={fields[columnFieldName]}
    onChange={handleFieldValue}
    timeInputLabel="Time:"
    dateFormat="MM/dd/yyyy h:mm aa"
    showTimeInput
  />
)

export default EditableColumn
